import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIMultipartRequest, APIRequest } from '../../common/Common';
import { getAlertMessageFunction } from '../../common/Util';
import { TARGET_YEAR_API } from '../../common/data';

const initialState = {
  isRender: false,
  reload: -1,
  dataList: [],

  uploadFlag: 'A', //A:통합, D:상세

  housingFundsCheckList: [], //주택자금 체크유무
  htm013: '',

  eDocumentStatus: {},
  // 파일리스트
  OriginFileList: [],

  uuid: '',

  htmMillionList: [], //100만원이상이라 기본공제 해제된애들

  isCert: false,
  linkToDataReload: -1,

  ntsResult: {},
};

// 주택체크 버튼 나오는유무
export const getHousingFundsCheck = createAsyncThunk(
  'eDocuments/getHousingFundsCheck',
  async () => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/getHouseQnaCheck`);
    return response;
  },
);

//통합/상세 flag 담는 거
export const getPDFUploadFlag = createAsyncThunk('eDocuments/getPDFUploadFlag', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/getPDFUploadFlag`);
  return response;
});

// 주택자금 status 담는애
export const getPDFMainLoad = createAsyncThunk('eDocuments/getPDFMainLoad', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}PDF/pdfMainLoad`);
  return response;
});

// 파일리스트
export const getPDFFileList = createAsyncThunk('eDocuments/getPDFFileList', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}PDF/pdfFileList`);
  return response;
});

// 파일전체삭제
export const deletePDFAll = createAsyncThunk('eDocuments/deletePDFAll', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}PDF/pdfDelete`);
  return response;
});

// 파일업로드
export const uploadPDF = createAsyncThunk('eDocuments/uploadPDF', async ({ data, onProgress }) => {
  const config = {
    onUploadProgress: progressEvent => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      onProgress?.(percentCompleted);
    },
  };

  const response = await APIMultipartRequest(`/${TARGET_YEAR_API}PDF/pdfUpload`, data, config);
  return response;
});

// 파일업로드 체크
export const getPDFUploadCheck = createAsyncThunk('eDocuments/getPDFUploadCheck', async data => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/getPDFUploadCheck`, data);
  return response;
});

// 전자문서 확정
export const pdfConfirm = createAsyncThunk('eDocuments/pdfConfirm', async data => {
  const response = await APIRequest(`/${TARGET_YEAR_API}PDF/pdfConfirm`, data);
  return response;
});

//국세청 인증 보내기
export const sendCertRequest = createAsyncThunk('/eDocuments/certRequest', async param => {
  const res = await APIRequest(`/${TARGET_YEAR_API}Hometax/certRequest`, param);
  return res;
});

//국세청 인증확인
export const sendCertConfirm = createAsyncThunk('/eDocuments/certConfirm', async param => {
  const res = await APIRequest(`/${TARGET_YEAR_API}Hometax/certConfirm`, param);
  return res;
});

//연동유무
export const certComplete = createAsyncThunk('/eDocuments/certComplete', async param => {
  const res = await APIRequest(`/${TARGET_YEAR_API}Hometax/certComplete`, param);
  return res;
});

//100만원 이상인사람들 체크
export const get100MillionCheck = createAsyncThunk('/eDocuments/100MillionCheck', async () => {
  const res = await APIRequest(`/${TARGET_YEAR_API}PDF/getCheckMillion`);
  return res;
});

//국세청 데이터
export const getPDFApply = createAsyncThunk('/eDocuments/PDFApply', async param => {
  const res = await APIRequest(`/${TARGET_YEAR_API}/PDFApply`, param);
  return res;
});

const eDocumentsSlice = createSlice({
  name: 'eDocuments',
  initialState,
  reducers: {
    resetEDocumentState: () => initialState, // 상태 리셋 액션 추가
    setReload: (state, action) => {
      state.reload = Math.random();
    },
    setUuid: (state, action) => {
      console.log('action.payload >>', action.payload);
      state.uuid = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(getHousingFundsCheck.fulfilled, (state, action) => {
      //주택자금 체크유무
      console.log(action.payload);
      const { resultData, resultCode } = action.payload;
      if (resultCode === '1') {
        state.housingFundsCheckList = resultData?.list || [];
      } else {
        state.housingFundsCheckList = [];
      }
    });
    builder.addCase(getPDFUploadFlag.fulfilled, (state, action) => {
      //통합/상세 flag 담는 거
      console.log('통합/상세 flag 담는 거', action.payload);
      state.uploadFlag = action?.payload?.uploadFlag || 'A';
    });
    builder.addCase(getPDFMainLoad.fulfilled, (state, action) => {
      //status 담는애
      console.log('status 담는애', action.payload);
      const { resultData, resultCode } = action.payload;
      if (resultCode === '1') {
        state.htm013 = resultData?.htm013 || '';
        state.eDocumentStatus = resultData || {};
      } else {
        state.eDocumentStatus = {};
        state.htm013 = '';
      }
    });
    builder.addCase(getPDFFileList.fulfilled, (state, action) => {
      //파일리스트
      const { resultData, resultCode } = action.payload;
      if (resultCode === '1') {
        state.OriginFileList = resultData || [];
      } else {
        state.OriginFileList = [];
      }
    });
    builder.addCase(deletePDFAll.fulfilled, (state, action) => {
      const alertMessage = getAlertMessageFunction();
      const { resultCode, resultMsg } = action.payload;
      if (resultCode === '1') {
        alertMessage(resultMsg);
        state.reload = Math.random();
      }
    });
    builder.addCase(uploadPDF.fulfilled, (state, action) => {});
    builder.addCase(sendCertConfirm.fulfilled, (state, action) => {
      const { resultCode } = action.payload;
      if (resultCode == '1') {
        state.linkToDataReload = Math.random();
      }
    });
    builder.addCase(certComplete.fulfilled, (state, action) => {
      const { resultCode, msg } = action.payload;
      if (resultCode == '0') {
        state.isCert = true;
      } else {
        state.isCert = false;
      }
    });
    builder.addCase(get100MillionCheck.fulfilled, (state, action) => {
      const { resultCode, resultData } = action.payload;
      if (resultCode == '1') {
        state.htmMillionList = resultData?.htmMillionList || [];
      } else {
        state.htmMillionList = [];
      }
    });
    builder.addCase(getPDFApply.fulfilled, (state, action) => {
      console.log('국세청 데이터', action.payload);
      state.ntsResult = action.payload;
    });
  },
});

export const { resetEDocumentState, setReload, setUuid } = eDocumentsSlice.actions;
export default eDocumentsSlice.reducer;
